/* @flow */

import moment from 'moment';

const dataFinalEInicialMesAtual = () => ({
    dataInicial: moment().format('Y-MM-01'),
    dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
});

export default dataFinalEInicialMesAtual;
